import type { FC } from 'react';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { YourTopicsVisitorView } from '@xing-com/crate-entity-pages-your-topics';
import { Flag } from '@xing-com/flag';

import { useHeaderContext } from '../../hooks/use-header-context/use-header-context';
import { EditPageInfoButton } from '../edit-page-info-button/edit-page-info-button';
import { TitleTooltip } from '../title-tooltip/title-tooltip';

import * as Styled from './primary-area.styles';

export const PrimaryArea: FC = () => {
  const { subtitle, title } = useHeaderContext();
  const { pageContext, isSubpage } = usePageContext();
  const isEditing = useEditStore(({ isEditing }) => isEditing);

  const { isFreePage, isInsiderPage } = pageContext;

  return (
    <Styled.PrimaryArea>
      <Styled.TitleContainer>
        <Styled.HeroContainer>
          <Styled.Hero
            size="small"
            className="title"
            data-cy="entityPageTitle"
            data-testid={!isSubpage ? 'PAGE_TITLE' : undefined}
          >
            {title}
          </Styled.Hero>
          {isInsiderPage ? (
            <Flag
              data-testid="HEADER_INSIDER_FLAG"
              gender="neutral"
              size="medium"
              variant="insider"
            />
          ) : null}
          {!isSubpage ? <TitleTooltip /> : null}
        </Styled.HeroContainer>
        {isSubpage && subtitle ? (
          <>
            <Styled.Subtitle>{subtitle}</Styled.Subtitle>
            <Styled.WhiteSpace>&nbsp;</Styled.WhiteSpace>
          </>
        ) : null}
      </Styled.TitleContainer>
      {!isSubpage && (subtitle || isEditing || isInsiderPage) ? (
        isInsiderPage ? (
          <YourTopicsVisitorView />
        ) : (
          <Styled.SubtitleContainer>
            <Styled.HeaderSubtitle
              size="small"
              noMargin
              sizeWide="medium"
              data-testid="PAGE_SLOGAN"
            >
              {subtitle}
            </Styled.HeaderSubtitle>
            {!isFreePage && isEditing ? (
              <>
                {/** TODO: check if this Button is ever used <EditPageInfoButton isLabel /> */}
                {!subtitle ? <EditPageInfoButton isLabel /> : null}
                {!isSubpage ? <EditPageInfoButton /> : null}
              </>
            ) : null}
          </Styled.SubtitleContainer>
        )
      ) : null}
    </Styled.PrimaryArea>
  );
};
